import {ArrowBack, Email, MonetizationOn, Payments} from '@mui/icons-material';
import {Button, Grid, Paper, TextField, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import SectionHeader from '../../../../util/component/SectionHeader';
import {useNavigate, useParams} from 'react-router-dom';
import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import dayjs from "dayjs";
import {useStatusValuesOrder} from '../../component/UserLegalEntitiesOrDealersInputGroup/useStatusValuesOrder';
import {useVoucherActions} from '../../service/useMobilityVoucherAction';
import {useHasScope} from '../../../../config/globalConfig';
import {ORDER_SELECTED} from '../../service/MobilityVoucherRecoil';
import {useRecoilState} from 'recoil';
import {GlobalContext} from '../../../../util/state/GlobalContextProvider';
import {snackbarTypes} from '../../../../util/state/globalVariables';
import CustomModal from "./modals/CustomModal";
import {CORRELATION_NAME_PBL, EMAIL, SMS} from "../../interfaces/Order";
import {setSnackbar} from "../../../../util/state/globalAction";

const MobilityVoucherDetailsOrder = () => {
    const {t} = useTranslation(['mobilityvoucher']);
    const navigate = useNavigate();
    const {id} = useParams();
    const {
        sendVoucherMail,
        detailsOrder,
        returnVoucherCode,
        unlockVoucher,
        createPayByLink,
        checkPayByLinkRequest
    } = useVoucherActions();
    const hasScope = useHasScope;
    const [orderPay, setOrderPay] = useRecoilState(ORDER_SELECTED);
    const [order, setOrder] = useState<any>();
    const [statusVoucher, setStatusVoucher] = useState<any>();
    const {getStatusLabelOrder} = useStatusValuesOrder();
    const [openPaymentMethodModal, setOpenPaymentMethodModal] = useState(false);
    const [openPaymentPayByLinkModal, setOpenPaymentPayByLinkModal] = useState(false);
    const [proceed, setProceed] = useState(false);
    const [byPos, setByPos] = useState(false);
    const [showEmailSMS, setShowEmailSMS] = useState(false);
    const [payByLinkChannel, setPayByLinkChannel] = useState("");
    const {dispatchGlobalData} = useContext(GlobalContext);
    type ButtonVariant = 'text' | 'outlined' | 'contained';

    const [buttonVariants, setButtonVariants] = useState<{
        buttonPos: ButtonVariant,
        buttonPay: ButtonVariant,
        buttonEmail: ButtonVariant,
        buttonSMS: ButtonVariant,
    }>({
        buttonPos: 'outlined',
        buttonPay: 'outlined',
        buttonEmail: 'outlined',
        buttonSMS: 'outlined',
    });


    const handleClick = (buttonId: keyof typeof buttonVariants) => {
        setButtonVariants({
            buttonPos: 'outlined',
            buttonPay: 'outlined',
            buttonEmail: 'outlined',
            buttonSMS: 'outlined',
            [buttonId]: 'contained'
        } as typeof buttonVariants);

    };


    useEffect(() => {
        detailsOrder(id).then((res) => {
            setOrder(res)
            setOrderPay(res)
        })

    }, [])


    const clickSendEmail = () => {
        sendVoucherMail(order.voucherCode)
            .then(function (response) {
                dispatchGlobalData({
                    type: 'SET_SNACKBAR',
                    payload: {
                        snackbar: {
                            message: t('mobilityvoucher:message.resendVoucher'),
                            type: snackbarTypes.success,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            })
            .catch(() => {
                dispatchGlobalData({
                    type: 'SET_SNACKBAR',
                    payload: {
                        snackbar: {
                            message: t('mobilityvoucher:addCustomer.error'),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            })
    }

    const clickUnlockVoucher = () => {
        unlockVoucher(order.voucherCode)
            .then(function (response) {
                detailsOrder(id).then((res) => {
                    setOrder(res)
                    setOrderPay(res)
                })
                dispatchGlobalData({
                    type: 'SET_SNACKBAR',
                    payload: {
                        snackbar: {
                            message: t('mobilityvoucher:message.unlockVoucher'),
                            type: snackbarTypes.success,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            })
            .catch(() => {
                dispatchGlobalData({
                    type: 'SET_SNACKBAR',
                    payload: {
                        snackbar: {
                            message: t('mobilityvoucher:addCustomer.error'),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            })
    }
    const paymentsOrder = async () => {
        setOpenPaymentMethodModal(true)
    }

    const clickRefundVoucher = () => {
        returnVoucherCode(order.voucherCode)
            .then(function (response) {
                detailsOrder(id).then((res) => {
                    setOrder(res)
                    setOrderPay(res)
                })
                dispatchGlobalData({
                    type: 'SET_SNACKBAR',
                    payload: {
                        snackbar: {
                            message: t('mobilityvoucher:message.refundVoucher'),
                            type: snackbarTypes.success,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            })
            .catch(() => {
                dispatchGlobalData({
                    type: 'SET_SNACKBAR',
                    payload: {
                        snackbar: {
                            message: t('mobilityvoucher:addCustomer.error'),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            })
    }


    function checkPayByLinkValid() {
        const verifyPaymentRequestObj = {
            linkCode: order.id
        }

        checkPayByLinkRequest(verifyPaymentRequestObj).then(
            () => {
                navigate('/mobilityvoucher/payment-order');
                setProceed(true)
            }
        );
    }

    function payByLink() {
        const payByLinkObject = {
            sku: order.subscription.sku,
            channel: payByLinkChannel,
            amount: parseFloat(order.amount),
            customerId: order.customer.sapId,
            orderId: order.id,
            correlationId: order.id,
            correlationName: CORRELATION_NAME_PBL + order.id,
            dealerId: order.dealerId,
            tenantId: order.tenantId
        }

        createPayByLink(payByLinkObject).then(
            (res) => {
                if (res) {
                    setOrder(res)
                    navigate("/mobilityvoucher/orders")
                } else {
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: t('mobilityvoucher:message.payByLinkError'),
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true,
                            }
                        }
                    });
                }
            }
        );
    }


    function handleNext() {
        checkPayByLinkValid();
    }

     const checkSirenVisibility = () => {
        return order?.customer?.siren !== "";
    }

    return (
        <>

            <Paper elevation={1} sx={{padding: "", margin: "18px"}}>
                {order ?
                    <>
                        <SectionHeader title={t('headerDeatilsOrder.title')} subtitle={
                            <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                <Grid>
                                    {t('headerDeatilsOrder.order') + ': ' + order.orderNumber + '    ' + t('headerDeatilsOrder.status') + ': ' + getStatusLabelOrder(order.orderState) + '    ' + t('headerDeatilsOrder.amount') + ': ' + parseFloat(order.amount) / 100 + ' €'}
                                </Grid>
                                <Grid>
                                    DMS: {order?.mobilityStore?.identificationCode} - {order?.mobilityStore?.name}
                                </Grid>
                            </Grid>

                        }/>
                        <form style={{display: 'flex'}}>
                            <Grid sx={{margin: '18px'}} container xs={12}>
                                <Grid item xs={6}>
                                    <h4>{t('mobilityvoucher:order_details.orderTitle')}</h4>
                                </Grid>
                                {order && <Grid spacing={2} container xs={12}>
                                    <Grid item xs={3}>
                                        <TextField value={dayjs(order.orderDate).format("lll")} fullWidth
                                                   label={t('mobilityvoucher:order_details.order.orderDate')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField value={getStatusLabelOrder(order.orderState)} fullWidth
                                                   label={t('mobilityvoucher:order_details.order.orderStatus')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        {order.orderState === "COMPLETED" ?
                                            <TextField value={order.voucherCode} fullWidth
                                                       label={t('mobilityvoucher:order_details.order.voucherCode')}
                                                       InputProps={{readOnly: true}}/>
                                            : null}
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField value={parseFloat(order.amount) / 100 + ' €'} fullWidth
                                                   label={t('mobilityvoucher:order_details.order.orderTotal')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>

                                </Grid>
                                }

                                <Grid item xs={6}>
                                    <h4>{t('mobilityvoucher:order_details.subscriptionTitle')}</h4>
                                </Grid>
                                {order.subscription && <Grid spacing={2} container xs={12}>
                                    <Grid item xs={3}>
                                        <TextField value={order.subscription.productCode} fullWidth
                                                   label={t('mobilityvoucher:order_details.subscription.code')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField value={order.subscription.name} fullWidth
                                                   label={t('mobilityvoucher:order_details.subscription.name')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField value={order.subscription.category} fullWidth
                                                   label={t('mobilityvoucher:order_details.subscription.category')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField value={order.subscription.sku} fullWidth
                                                   label={t('mobilityvoucher:order_details.subscription.sku')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>

                                </Grid>
                                }

                                <Grid item xs={6}>
                                    <h4>{t('mobilityvoucher:order_details.customerTitle')}</h4>
                                </Grid>
                                {order.customer && <Grid spacing={2} container xs={12}>
                                    <Grid item xs={3}>
                                        <TextField value={order.customer.lastName || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.lastName')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField value={order.customer.firstName || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.firstName')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField value={order.customer.taxCode || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.taxCode')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField value={order.customer.email || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.email')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                </Grid>}
                                {order.customer && <Grid spacing={2} container xs={12}>
                                    <Grid item xs={3}>
                                        <TextField value={order.customer.companyName || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.companyName')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField value={order.customer.vatNumber || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.vatNumber')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    {
                                        checkSirenVisibility() &&
                                        <>
                                            <Grid item xs={3}>
                                                <TextField value={order.customer.siren || ' '} fullWidth
                                                           label={t('mobilityvoucher:order_details.customer.siren')}
                                                           InputProps={{readOnly: true}}/>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <TextField value={order.customer.siret || ' '} fullWidth
                                                           label={t('mobilityvoucher:order_details.customer.siret')}
                                                           InputProps={{readOnly: true}}/>
                                            </Grid>
                                        </>
                                    }
                                </Grid>}
                                {order.customer.billingAddress ?
                                    <>
                                        <Grid item xs={6}>
                                            <h4>{t('mobilityvoucher:order_details.billingAddress')}</h4>
                                        </Grid>
                                        {order.customer && <Grid spacing={2} container xs={12}>
                                            <Grid item xs={3}>
                                                <TextField value={order.customer.billingAddress?.country || ' '}
                                                           fullWidth
                                                           label={t('mobilityvoucher:order_details.customer.country')}
                                                           InputProps={{readOnly: true}}/>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <TextField value={order.customer.billingAddress?.province || ' '}
                                                           fullWidth
                                                           label={t('mobilityvoucher:order_details.customer.province')}
                                                           InputProps={{readOnly: true}}/>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <TextField value={order.customer.billingAddress?.city || ' '} fullWidth
                                                           label={t('mobilityvoucher:order_details.customer.city')}
                                                           InputProps={{readOnly: true}}/>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <TextField value={order.customer.billingAddress?.zipCode || ' '}
                                                           fullWidth
                                                           label={t('mobilityvoucher:order_details.customer.zipCode')}
                                                           InputProps={{readOnly: true}}/>
                                            </Grid>

                                        </Grid>
                                        }
                                        <Grid spacing={2} container xs={12}>
                                            <Grid item xs={3}>
                                                <TextField value={order.customer.billingAddress?.street || ' '}
                                                           fullWidth
                                                           label={t('mobilityvoucher:order_details.customer.address')}
                                                           InputProps={{readOnly: true}}/>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <TextField value={order.customer.billingAddress?.addressNumber || ' '}
                                                           fullWidth
                                                           label={t('mobilityvoucher:order_details.customer.addressNumber')}
                                                           InputProps={{readOnly: true}}/>
                                            </Grid>
                                        </Grid>
                                    </>
                                    :
                                    <>
                                        <Grid item xs={6}>
                                            <h4>{t('mobilityvoucher:order_details.address')}</h4>
                                        </Grid>
                                        {order.customer && <Grid spacing={2} container xs={12}>
                                            <Grid item xs={3}>
                                                <TextField value={order.customer.address?.country || ' '} fullWidth
                                                           label={t('mobilityvoucher:order_details.customer.country')}
                                                           InputProps={{readOnly: true}}/>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <TextField value={order.customer.address?.city || ' '} fullWidth
                                                           label={t('mobilityvoucher:order_details.customer.city')}
                                                           InputProps={{readOnly: true}}/>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <TextField value={order.customer.address?.province || ' '} fullWidth
                                                           label={t('mobilityvoucher:order_details.customer.province')}
                                                           InputProps={{readOnly: true}}/>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <TextField value={order.customer.address?.zipCode || ' '} fullWidth
                                                           label={t('mobilityvoucher:order_details.customer.zipCode')}
                                                           InputProps={{readOnly: true}}/>
                                            </Grid>
                                        </Grid>
                                        }
                                        <Grid spacing={2} container xs={12}>
                                            <Grid item xs={3}>
                                                <TextField value={order.customer.address?.street || ' '} fullWidth
                                                           label={t('mobilityvoucher:order_details.customer.address')}
                                                           InputProps={{readOnly: true}}/>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <TextField value={order.customer.address?.addressNumber || ' '}
                                                           fullWidth
                                                           label={t('mobilityvoucher:order_details.customer.addressNumber')}
                                                           InputProps={{readOnly: true}}/>
                                            </Grid>
                                        </Grid>
                                    </>
                                }
                            </Grid>
                        </form>
                    </>
                    : null}

                {order ?
                    <>
                        {order.orderState === "COMPLETED" ?
                            <><Grid sx={{margin: '18px'}} item xs={12} display={"flex"} justifyContent={"space-between"}
                                    alignItems={"center"} pb={5} pt={4}>
                                <Grid>
                                    {/* <Button startIcon={<ArrowBack />} onClick={() => backPageOrder()} size='smallPlus' variant="outlined" sx={{ mr: 1 }}>{t('mobilityvoucher:buttons.back')}</Button> */}
                                    {order.voucherState === "AVAILABLE" ?
                                        <>{hasScope('SCOPE_MV_ORDERS_CREATE') ?
                                            <Button endIcon={<Email/>} onClick={clickSendEmail} size='smallPlus'
                                                    variant="outlined">{t('mobilityvoucher:buttons.resendVoucher')}</Button> : <></>
                                        }
                                        </>
                                        : <></>}
                                </Grid>
                                <Grid>
                                    {order.voucherState === "ON_HOLD" ?
                                        <>{hasScope('SCOPE_MV_ORDERS_UNLOCK') ?
                                            <Button size='smallPlus' onClick={clickUnlockVoucher} variant="outlined"
                                                    sx={{mr: 1}}>{t('mobilityvoucher:buttons.unlockVoucher')}</Button> : <></>
                                        }
                                        </>
                                        : <></>}
                                    {/* <>{hasScope('SCOPE_MV_ORDERS_DETAILS_VIEW')?
                    <Button endIcon={<FileDownload />} size='smallPlus' variant="outlined" sx={{ mr: 1 }}>{t('mobilityvoucher:buttons.invoicePDF')}</Button>:<></>
                  }
                  </> */}

                                    <>{hasScope('SCOPE_MV_ORDERS_CREATE') ?
                                        <Button startIcon={<MonetizationOn/>} onClick={clickRefundVoucher}
                                                size='smallPlus'>{t('mobilityvoucher:buttons.refund')}</Button> : <></>
                                    }
                                    </>
                                </Grid>
                            </Grid>
                            </>
                            :
                            null
                        }
                        {order.orderState === "NOT_COMPLETED" ?
                            <> <Grid sx={{margin: '18px'}} item xs={12} display={"flex"}
                                     justifyContent={"space-between"} alignItems={"center"} pb={5} pt={4}>
                                <Grid>
                                    {/* <Button startIcon={<ArrowBack />} onClick={() => backPageOrder()} size='smallPlus' variant="outlined" sx={{ mr: 1 }}>{t('mobilityvoucher:buttons.back')}</Button> */}
                                </Grid>
                                <Grid>
                                    <>{hasScope('SCOPE_MV_ORDERS_CREATE') ?
                                        <Button startIcon={<Payments/>} onClick={paymentsOrder}
                                                size='smallPlus'>{t('mobilityvoucher:buttons.goToPayment')}</Button> : <></>
                                    }
                                    </>
                                </Grid>
                            </Grid></>
                            :

                            null
                        }

                    </>
                    : null}
            </Paper>
            <CustomModal title={t('order_details.paymentMethod.title')}
                         content={() =>
                             <>
                                 <Grid container item display={"flex"} justifyContent={"space-evenly"}>
                                     <Button variant={buttonVariants.buttonPos} color={"accent"} size={"medium"}
                                             onClick={() => {
                                                 setProceed(true)
                                                 setByPos(true)
                                                 handleClick("buttonPos");
                                             }}>
                                         {t('order_details.paymentMethod.pos')}
                                     </Button>
                                     <Button variant={buttonVariants.buttonPay} color={"accent"} size={"medium"}
                                             onClick={() => {
                                                 setShowEmailSMS(true)
                                                 setProceed(true)
                                                 setByPos(false)
                                                 handleClick("buttonPay");
                                             }}
                                     >
                                         {t('order_details.paymentMethod.payByLink')}
                                     </Button>
                                 </Grid>

                             </>
                         }
                         cancelButton={t('order_details.paymentMethod.close')}
                         confirmButton={t('order_details.paymentMethod.proceed')}
                         callback={() => {
                             if (byPos) {
                                 handleNext()
                             } else {
                                 setOpenPaymentPayByLinkModal(true)
                                 setOpenPaymentMethodModal(false)
                             }
                         }
                         }
                         disableButton={!proceed}
                         open={openPaymentMethodModal}
                         onClose={() => {
                             setProceed(false)
                             setOpenPaymentMethodModal(false);
                         }}
            />

            <CustomModal title={''}
                         titleIcon={
                             <Button color="accent" size={"small"} title={t('order_details.paymentMethod.title')}
                                     variant="text" startIcon={<ArrowBack/>}
                                     onClick={() => {
                                         setProceed(false)
                                         setOpenPaymentPayByLinkModal(false);
                                         setOpenPaymentMethodModal(true);
                                     }}>
                                 <Typography fontWeight={"bold"} color={"primary"}>
                                     {t('order_details.paymentMethod.titlePayByLink')}
                                 </Typography>
                             </Button>
                         }
                         content={() =>
                             <>
                                 <Grid container display={"flex"} justifyContent={"space-evenly"}>
                                     <Button variant={buttonVariants.buttonEmail} color={"accent"} size={"medium"}
                                             onClick={() => {
                                                 setProceed(true)
                                                 handleClick("buttonEmail");
                                                 setPayByLinkChannel(EMAIL)
                                             }}>
                                         {t('order_details.paymentMethod.email')}
                                     </Button>
                                     <Button variant={buttonVariants.buttonSMS} color={"accent"} size={"medium"}
                                             onClick={() => {
                                                 setProceed(true)
                                                 handleClick("buttonSMS");
                                                 setPayByLinkChannel(SMS)
                                             }}>
                                         {t('order_details.paymentMethod.sms')}
                                     </Button>
                                 </Grid>
                             </>
                         }
                         cancelButton={t('order_details.paymentMethod.close')}
                         confirmButton={t('order_details.paymentMethod.proceed')}
                         callback={() => payByLink()}
                         disableButton={!proceed}
                         open={openPaymentPayByLinkModal}
                         onClose={() => {
                             setShowEmailSMS(false)
                             setProceed(false)
                             setOpenPaymentPayByLinkModal(false);
                         }}/>
        </>
    );
};

export default MobilityVoucherDetailsOrder;